import React from "react";
import { Link } from "react-router-dom";
import { Dots } from "react-dot-patterns";
import heroSectionImage from "../../../assets/service-hero-image.jpg";

const HeroSection = () => {
  return (
    <div className="manufacturing-hero-section-wrapper">
      <div className="dots1">
        <Dots
          col={6}
          row={4}
          size={5}
          rotate={0}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={10}
        />
      </div>
      <div className="dots2">
        <Dots
          col={3}
          row={4}
          size={5}
          rotate={0}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
        />
      </div>
      <div className="row">
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>
              Drive
              <br />
              <span>Efficiency and Optimize</span>
              <br /> Production
            </h1>
            <p>
              In the highly competitive manufacturing sector, maximizing
              operational efficiency, maintaining asset reliability, and
              ensuring compliance are critical for success. Soori Corporation
              provides comprehensive software solutions designed to help
              manufacturers streamline production processes, manage inventories,
              and keep assets in optimal condition.
            </p>
            <Link to="/services">Book A Meeting</Link>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={heroSectionImage} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
